import i18n from '@/plugins/i18n';

const queryCBGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      title: i18n.global.t('dbm.requests-label'),
      header: {
        title: i18n.global.t('dbm.requests-label'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#9bb6ff', '#29eeca'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_couchbase_nodes_query_request_completed_count,meter_couchbase_nodes_query_request_active_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.count'),
      },
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.request-time-distribution'),
      header: {
        title: i18n.global.t('dbm.request-time-distribution'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#29eeca', '#9bb6ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_couchbase_nodes_query_request_time_mean,meter_couchbase_nodes_query_request_time_median,meter_couchbase_nodes_query_request_time_95percentile,meter_couchbase_nodes_query_request_time_99percentile',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
      aggregation: '/',
      aggregationNum: '100',
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.request-thread-count'),
      header: {
        title: i18n.global.t('dbm.request-thread-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_query_total_threads',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.request-thread-count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.request-thread-count'),
      },
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.gc-count'),
      header: {
        title: i18n.global.t('dbm.gc-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#9bb6ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_gcnum',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.count'),
      },
    },
  ],
});
export default queryCBGraphs;
